<template>
  <div class="content-image-text">
    <div class="inner">
      <div class="imagewrapper" :class="[`-${data.imagePlacement}`]">
        <Image
          v-if="data.image && data.image.responsiveImage"
          class="image"
          :data="data.image.responsiveImage"
          object-fit="cover"
        />
      </div>
      <div class="text">
        <h2 v-if="data.title" class="title text-2xl" v-html="data.title" />
        <p v-if="data.leadText" class="lead">{{ data.leadText }}</p>
        <StructuredText v-if="data.text" :data="data.text" class="structured-text content text-lg" />
        <Link v-if="data.cta?.link" :link="data.cta?.link" class="button-link" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Image, StructuredText } from 'vue-datocms';
import Link from '~/components/content-modules/components/Link.vue';
import type { ContentImagetextFragment } from '#gql';

defineProps<{
  data: ContentImagetextFragment;
}>();
</script>

<style scoped lang="scss">
.content-image-text {
  @include grid-layout();

  & {
    padding: var(--site-inner-padding);
    width: 100%;
    max-width: var(--site-max-width);
  }

  @media (--xs), (--sm) {
    margin: var(--spacing-xs) 0;
  }

  @media (--md), (--lg) {
    margin: var(--spacing-2xl) 0;
  }

  > .inner {
    width: 100%;
    height: 100%;
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    place-items: center;
    gap: var(--spacing-xl);

    @media (--xs), (--sm) {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-2xs);
    }

    > .imagewrapper {
      width: 100%;

      > .image {
        width: 100%;
        max-width: 100%;
        aspect-ratio: 4 / 3;
      }

      &.-right {
        @media (--md), (--lg) {
          order: 1;
        }
      }
    }

    > .text {
      width: 100%;
      display: flex;
      gap: var(--spacing-3xs);
      flex-direction: column;
      align-items: flex-start;
    }
  }
}
</style>
